import React, {useState} from 'react';
import {Box} from '@mui/material';
import {Link} from 'react-router-dom';
import AurPermissionGroupSelect from '../../../common/aur-select/AurPermissionGroupSelect';

const items = [
  {
    ItemKey: '520D01D8-5563-4E59-964B-031696219610',
    ItemName: 'Permission Group #1 Case manager',
    ItemDescription:
      'Client manager has access to all client reports, as well as PII privileges and ability to manage departments and project groups. ',
    ItemFeatures: [
      'Processing in Progress',
      'Processing Summary',
      'High Level Production Metrics',
    ],
    ItemFeaturesForECI: [],
    ItemFeaturesForBudget: [],
    ItemEvidenceSourceManagement: [],
    ItemFeaturesForSystem: [],
    ItemFeaturesForManageProject: [],
    ItemFeaturesForBusinessIntelligence: [],
  },
  {
    ItemKey: '520D01D8-5563-4E59-964B-031696219611',
    ItemName: 'Permission Group #2 Reviewer',
    ItemDescription:
      'Responsible for assisting with collecting, processing, and reviewing electronic data.',
    ItemFeatures: [
      'Processing in Progress',
      'Processing Summary',
      'High Level Production Metrics',
      'Processing Exceptions',
      'Interactive Volume',
    ],
    ItemFeaturesForECI: [],
    ItemFeaturesForBudget: [],
    ItemEvidenceSourceManagement: [],
    ItemFeaturesForSystem: [],
    ItemFeaturesForManageProject: [],
    ItemFeaturesForBusinessIntelligence: [],
  },
  {
    ItemKey: '520D01D8-5563-4E59-964B-031696219612',
    ItemName: 'Contributor',
    ItemDescription:
      'Responsible for examining documents and electronic data to determine their relevance, responsiveness, and potential privilege.',
    ItemFeaturesForECI: [],
    ItemFeatures: ['Processing in Progress', 'Invoice'],
    ItemFeaturesForBudget: [],
    ItemEvidenceSourceManagement: [],
    ItemFeaturesForSystem: [],
    ItemFeaturesForManageProject: [],
    ItemFeaturesForBusinessIntelligence: [],
  },
  {
    ItemKey: '520D01D8-5563-4E59-964B-031696219613',
    ItemName: 'Informed',
    ItemDescription:
      'Responsible for examining documents and electronic data to determine their relevance, responsiveness, and potential privilege.',
    ItemFeatures: [
      'Processing in Progress',
      'Processing Summary',
      'High Level Production Metrics',
      'User Summary',
      'Processing Exceptions',
      'Interactive Volume',
      'Production Metrics',
      'Invoice',
      'GRO Servicing Team',
      'Project Tracker',
      'Budget Tracker',
      'Aurora User History',
    ],
    ItemFeaturesForECI: ['Admin', 'create doc'],
    ItemFeaturesForBudget: [],
    ItemEvidenceSourceManagement: [],
    ItemFeaturesForSystem: [],
    ItemFeaturesForManageProject: [],
    ItemFeaturesForBusinessIntelligence: [],
  },
];

const PermissionGroupSelect: React.FC = () => {
  const [selectedItem, setSelectedItem] = useState<string>('');

  return (
    <>
      <div style={{marginBottom: '64px'}}>
        <h1>Permission Group Select</h1>
        <Link to="/demo">Return</Link>
        <hr />
        <div className="permission-group-select">
          <Box className={'permission-group-dropdown'}>
            {
              <AurPermissionGroupSelect
                disabled={false}
                items={items}
                value={selectedItem}
                onChange={(value) => setSelectedItem(value)}
                label={'Permission group label'}
                clientId="123"
              />
            }
          </Box>
        </div>
      </div>
    </>
  );
};

export default PermissionGroupSelect;
